import React from 'react';
import { Button, ButtonColor, ButtonSize } from 'ui-builder';
import { Button as ShadcnButton } from 'shadcn-ui';
import { Loader2 } from 'lucide-react';
import useFeatureToggleService from 'feature-toggle';

export interface SubmitPopupButtonProps {
  text?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: () => Promise<void>;
  size?: ButtonSize;
  color?: ButtonColor;
}

function LegacySubmitPopupButtonLayout(props: SubmitPopupButtonProps) {
  const text = props.text || 'Submit';

  const size = props.size || ButtonSize.BIG;
  const color = props.color || ButtonColor.GREEN;

  const onClickFunc = async () => {
    await props.onClick();
  };

  return (
    <Button
      text={text}
      onClick={onClickFunc}
      color={color}
      size={size}
      isSubmitButton
    />
  );
}

function ShadcnSubmitPopupButtonLayout(props: SubmitPopupButtonProps) {
  const text = props.text || 'Submit';

  return (
    <ShadcnButton
      type="submit"
      disabled={props.isDisabled || props.isLoading}
      onClick={async (e) => {
        e.preventDefault();
        await props.onClick();
      }}
    >
      {props.isLoading && <Loader2 className="animate-spin" />}
      {text}
    </ShadcnButton>
  );
}

export default function SubmitPopupButtonLayout(props: SubmitPopupButtonProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnSubmitPopupButtonLayout {...props} />;
  } else {
    return <LegacySubmitPopupButtonLayout {...props} />;
  }
}
